// components/Loading.js
import React from 'react';
import { Spin } from 'antd';
import { LucidLoader } from '../../components/Icons';

export default function GenericLoaderComponent({
    isLoading,
    tip = 'Loading...',
    overlay = true,
    children,
    style,
    spinnerSize = 'large',
}) {
    if (overlay) {
        return isLoading ? (
            <div style={{ ...overlayStyle, ...style }}>
                <Spin indicator={<LucidLoader additionalClass={'text-primaryColor h-5'} />} size={spinnerSize} tip={tip} />
            </div>
        ) : (
            children || null
        );
    }

    return (
        <Spin spinning={isLoading} tip={tip} size={spinnerSize}>
            {children || <div style={{ width: 24, height: 24 }} />}
        </Spin>
    );
}

const overlayStyle = {
    position: 'fixed',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'rgba(17, 24, 39, 0.35)',
    backdropFilter: 'blur(2px)',
    zIndex: 2000,
};
